import { NewRideType } from "@/modules/concierge/new-ride/ConciergeNewRide";
import { X4bLocation } from "@/modules/concierge/views/PlacesRepository";
import { BookingType } from "@/modules/vehicle/engine/ActivityTypes";
import moment from "moment";

export function isAkDebug() {
	return localStorage.getItem('isAkDebug') === 'true';
}

export function debugLog(msg: string) {
	const isDebugMode = localStorage.getItem('isAkDebug') === 'true';
	if (!isDebugMode) return;
	console.log(msg);
}

export function newRideDebugDefaults() {
	const isDebugMode = localStorage.getItem('isAkDebug') === 'true';
	return isDebugMode ? {
		bookingType: BookingType.Asap,
		firstName: "Alex1",
		lastName: "Test1",
		phone: "9123456777",
		pickUpAddress: {
			PlaceName: "Rua Conde dos Arcos, 380",
			Address: "Rua Conde dos Arcos, 380 - Lindoia, Curitiba",
			Latitude: -25.446152899999998,
			Longitude: -49.277920699999996
		} as X4bLocation,
		dropOffAddress: {
			PlaceName: "Rua Conde dos Arcos, 380",
			Address: "R. Pasteur, 90 - Batel, Curitiba",
			Latitude: -25.440669399999997,
			Longitude: -49.2810261
		} as X4bLocation
	} as NewRideType : {
		bookingType: BookingType.Scheduled
	};
}
export function newRideDebugDefaults1() {
	const isDebugMode = localStorage.getItem('isAkDebug') === 'true';
	return isDebugMode ? {
		bookingType: BookingType.Scheduled,
		firstName: "Alex1",
		lastName: "Test1",
		phone: "9123456777",
		pickUpAddress: {
			PlaceName: "Rua Conde dos Arcos, 380",
			Address: "Rua Conde dos Arcos, 380 - Lindoia, Curitiba",
			Latitude: -25.446152899999998,
			Longitude: -49.277920699999996
		} as X4bLocation,
		dropOffAddress: {
			PlaceName: "R. Pasteur",
			Address: "R. Pasteur, 90 - Batel, Curitiba",
			Latitude: -25.440669399999997,
			Longitude: -49.2810261
		} as X4bLocation,
		date: moment().startOf('day'),
		timeInSeconds: 18 * 3600
	} as NewRideType : {
		bookingType: BookingType.Scheduled
	};
}
